import { httpRequest } from "../../http";

export class CommandSetBrandDefaultLogo {
    async run(organizationId: string, brandId: string, assetId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/default-logo/${assetId}`;
        const response = await httpRequest<any>(url, { method: "POST" });
        return response;
    }
}
